import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { Field } from './logic-services/models';

@Injectable({
    providedIn: 'root'
})
export class FieldsService {
    private _fields: Field[] = [];
    fields: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
    repoFields: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
    fieldsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor() {
        const _fields = JSON.parse(sessionStorage.getItem('fields'));
        if (_fields) {
            this.setFields(_fields);
        }

        const _repoFields = JSON.parse(sessionStorage.getItem('repoFields'));
        if (_repoFields) {
            this.setFields(_repoFields);
        }
    }

    disconnect() {
        sessionStorage.removeItem('repoFields');
        this.repoFields.next(null);
    }

    setFields(fields: any[]) {
        sessionStorage.setItem('fields', JSON.stringify(fields));
        this._fields = fields;
        this.fields.next(fields);
    }

    getFieldList(): Field[] {
        return this._fields;
    }

}
